export const feature_flag = {
  CREATE_CLAIM_INSPECTION: "portal.claims.createinspection",
  BROKER_INVITE_TO_EXISTING_ORG: "portal.invitations.existingorganisation",
};
